import React from 'react';
import { withRouter, Redirect, Route, Switch } from 'react-router-dom';

import Home from '../../Pages/Home/Home';
import UserDetails from '../../Pages/UserDetails/UserDetails';
import UserForm from '../../Pages/UserForm/UserForm';
import VendorDetails from '../../Pages/VendorDetails/VendorDetails';
import VendorForm from '../../Pages/VendorForm/VendorForm';
import CustomerDetails from '../../Pages/CustomerDetails/CustomerDetails';
import CustomerForm from '../../Pages/CustomerForm/CustomerForm';
import ItemDetails from '../../Pages/ItemDetails/ItemDetails';
import Transactions from '../../Pages/Transactions/Transactions';
import ItemForm from '../../Pages/ItemForm/ItemForm';
import ItemCategory from '../../Pages/ItemCategory/ItemCategory';
import PaymentMethod from '../../Pages/PaymentMethod/PaymentMethod';
import Commission from '../../Pages/Commission/Commission';
import ItemLocation from '../../Pages/ItemLocation/ItemLocation';
import EntityGroup from '../../Pages/EntityGroup/EntityGroup';
import LocationDetails from '../../Pages/LocationDetails/LocationDetails';
import InventoryTransfer from '../../Pages/InventoryTransfer/InventoryTransfer';
import LoginForm from '../../Pages/LoginForm/LoginForm';
import Logout from '../../Pages/Logout/Logout';
import Header from '../Header/Header';
import CheckIn from '../../Pages/CheckIn/CheckIn';
import CheckOut from '../../Pages/CheckOut/CheckOut';
import Reports from '../../Pages/Reports/Reports';
import Imports from '../../Pages/Imports/Imports';
import UserDashboard from '../../Pages/UserDashboard/UserDashboard';
import { isAuthenticated } from '../../apiClient';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      isAuthenticated()
        ? <Component {...props} />
        : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    )}
  />
);

const Routes = () => {

  // Hide Header from Login Page
  let header = (window.location.pathname === '/' || !isAuthenticated()) ? '' : <Header />;
  
  return (
    <div>
     {header}
    <Switch>
        <Route exact={true} path="/" component={LoginForm} />
        <PrivateRoute exact={true} path="/home" component={Home} />
        <PrivateRoute exact={true} path="/user-dashboard" component={UserDashboard} />
        <PrivateRoute exact={true} path="/user-form" component={UserForm} />
        <PrivateRoute exact={true} path="/user-details" component={UserDetails} />
        <PrivateRoute exact={true} path="/vendor-form" component={VendorForm} />
        <PrivateRoute exact={true} path="/vendor-details" component={VendorDetails} />
        <PrivateRoute exact={true} path="/customer-form" component={CustomerForm} />
        <PrivateRoute exact={true} path="/customer-details" component={CustomerDetails} />
        <PrivateRoute exact={true} path="/item-form" component={ItemForm} />
        <PrivateRoute exact={true} path="/item-category" component={ItemCategory} />
        <PrivateRoute exact={true} path="/payment-method" component={PaymentMethod} />
        <PrivateRoute exact={true} path="/commission" component={Commission} />
        <PrivateRoute exact={true} path="/item-location" component={ItemLocation} />
        <PrivateRoute exact={true} path="/entity-group" component={EntityGroup} />
        <PrivateRoute exact={true} path="/location-details" component={LocationDetails} />
        <PrivateRoute exact={true} path="/inventory-transfer" component={InventoryTransfer} />
        <PrivateRoute exact={true} path="/item-details" component={ItemDetails} />
        <PrivateRoute exact={true} path="/transactions" component={Transactions} />
        <PrivateRoute exact={true} path="/intake" component={CheckIn} />
        <PrivateRoute exact={true} path="/return" component={CheckIn} />
        <PrivateRoute exact={true} path="/CheckOut" component={CheckOut} />
        <PrivateRoute exact={true} path="/Reports" component={Reports} />
        <PrivateRoute exact={true} path="/Imports" component={Imports} />

        <Route exact={true} path="/logout" component={Logout} />
    </Switch>
    </div>
  );
}

export default withRouter(Routes);
